<!-- Module -->
<section *ngIf="!quizStart">

    <!-- Title -->
    <div class="text-center">
        <h1>Module 7 - Property Management Questions</h1>
    </div>

    <!-- Module Content -->
    <div class="container content-box module-content text-center">
        <app-youtube-player #video src="https://www.youtube.com/embed/twCg0lx6vTo" width="900" height="620" autoplay></app-youtube-player>
    </div>

    <!-- Navigation Buttons -->
    <div class="container navigate-buttons">
        <button type="button" class="btn waves-dark w-25" [routerLink]="'/module6-fhe'"><i class="fas fa-angle-left mr-3"></i>Previous</button>
        <button type="button" class="btn waves-dark w-25" (click)="startQuiz($event)" [delay-click]="video.duration / video.speed" [delay-until]="video.isCompleted" delay-tooltip="Watch the whole video to the end first.">Quiz<i class="fas fa-angle-right ml-3"></i></button>
    </div>
</section>

<!-- Quiz Mode -->
<section *ngIf="quizStart">
    <app-quiz-questions [questions]="questions" [moduleNumber]="7" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>
